import React from 'react';

import cockroachIcon from 'assets/images/encounter-icon/encounter_mouse.svg';

interface EncSvgProps {
  size?: number;
  className?: string;
}

const EncSvg: React.FC<EncSvgProps> = ({ size = 38, className }) => {
  return <img src={cockroachIcon} width={size} height={size} className={className} alt="encounter icon" />;
};

export default EncSvg;
